import { http } from "@/http";
import { casterapi } from "@/http";
import stationsData from "@/assets/jsons/stations_filtered.json";
class MonitoringService {
  async getMonitoringList() {
    return await http.get(`/monitoring/all-mountpoint-monitoring`);
  }
  async getMonitoringListPaginated(params) {
    return await http.get(`/monitoring/mountpoint-monitoring-pagination`, {
      params,
    });
  }
  async getMonitoringListPaginatedFiltered(params) {
    // return await http.get(`/monitoring/mountpoint-monitoring-pagination`, {
    //   params,
    // });
    return await new Promise(() => {
      let response = { data: stationsData[params["page"]] };
      return response;
    });
  }
  async getMonitoringMapPaginated(body,signal) {
    let params = {};
    params["size"] = body["size"];
    params["page"] = body["page"];
    params["topleft"] = body["topLeft"]
      ? body["topLeft"][0] + "," + body["topLeft"][1]
      : null;
    params["bottomright"] = body["bottomRight"]
      ? body["bottomRight"][0] + "," + body["bottomRight"][1]
      : null;
console.log('In service',params);
    return await http.get(`/monitoring/mountpoint-monitoring-pagination`, {
      params,
      signal // Include the abort signal in the request options
    });
  }
  async getMonitoring(baseStation) {
    return await http.get(
      `/monitoring/all-mountpoint-monitoring/${baseStation}`
    );
  }
  async getMetrics(id, start, end) {
    console.log(id, start, end);
    let copy = casterapi;
    copy.defaults.timeout = 60000;
    let body = {
      mountpoint: id,
      start: start,
      end: end,
    };
    return await copy.post("/dataset/bytes", body);
  }
}
export default new MonitoringService();
